import './tag.css';

export const Tag = ({ tag }) => {
  return <div className="tag-container">{tag.NAME}</div>;
};
